<div class="notification px-lg-2 pb-lg-2">
    <p class="mb-1 p-item">{{"misc.latest_purchase" | translate}}</p>
    <span class="d-none d-lg-block">/ / / / / / / / / / / / / / / /</span>
    <span class="d-flex d-lg-none">/ /</span>
    <div class="notify-wrap">
        <p class="mb-0" *ngFor="let item of transactions">
            [{{item.user | trimAddress}}] {{'misc.purchase_text' | translate : {amount:item.usdEq} }}
        </p>
    </div>
</div>